import { styled } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
import SvgRating from "./images/rating.svg.js";
import SvgRatingStroke from "./images/ratingStroke.svg.js";
const StyledRatingButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  position: "relative",
  color: theme.palette.grey[400],
  border: "none",
  backgroundColor: theme.palette.white.main,
  padding: 0,
  height: "18px"
})), StyledRatingItem = styled(
  SvgRating,
  shouldNotForwardProps(["isHovered", "isActive", "readOnly"])
)(({ theme, isHovered, isActive, readOnly }) => ({
  cursor: "pointer",
  ...readOnly && {
    cursor: "default",
    pointerEvents: "none"
  },
  ...(isHovered || isActive) && {
    color: theme.palette.sunnyYellow[800]
  }
})), StyledRatingStokeItem = styled(
  SvgRatingStroke,
  shouldNotForwardProps(["isHovered", "isActive", "readOnly"])
)(({ theme, readOnly }) => ({
  cursor: "pointer",
  color: theme.palette.sunnyYellow[800],
  ...readOnly && {
    cursor: "default",
    pointerEvents: "none"
  }
})), StyledRatingItemForShowContainer = styled("div")(({ theme }) => ({
  color: theme.palette.sunnyYellow[800],
  position: "absolute",
  left: 0,
  right: 0,
  overflow: "hidden",
  whiteSpace: "nowrap",
  height: "100%",
  display: "flex",
  alignItems: "center",
  width: "fit-content"
})), StyledRatingItemForShow = styled(
  SvgRating,
  shouldNotForwardProps(["isHovered", "isActive", "readOnly"])
)(({ theme, isHovered, isActive, readOnly }) => ({
  marginRight: "6px",
  color: theme.palette.sunnyYellow[800],
  ...(isHovered || isActive) && {
    color: theme.palette.sunnyYellow[800]
  },
  cursor: "pointer",
  ...readOnly && {
    cursor: "default",
    pointerEvents: "none"
  },
  "&:last-child": {
    marginRight: 0
  }
}));
export {
  StyledRatingButton,
  StyledRatingItem,
  StyledRatingItemForShow,
  StyledRatingItemForShowContainer,
  StyledRatingStokeItem
};
//# sourceMappingURL=styles.js.map
